import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { routesData } from 'src/app/shared/resources/routes.constant';

@Component({
  selector: 'app-upload-documents-error-dialog',
  templateUrl: './upload-documents-error-dialog.component.html',
  styleUrls: ['./upload-documents-error-dialog.component.scss']
})
export class UploadDocumentsErrorDialogComponent {
  constructor(private router: Router) {}

  public redirect() {
    this.router.navigate([routesData.DIGITAL_SIGNATURE.path]);
  }
}
